module.exports = __webpack_public_path__ + "static/media/pool3.cefde09c.jpg";